<template>
    <div class="card">
        <div class="card-header p-2">
            <div class="row">
                <div class="col-md-10 d-flex align-items-center">
                    <strong>{{ 'Partners > Category' }}</strong>
                </div>
                <div class="col-md-2">
                    <goback></goback>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <vue-tabs direction="horizontal" @tab-change="getTabData" active-text-color="black" v-model="curTab">
                <v-tab title="marketing">
                    <CategoryCompo :getUrl="getUrl" :createUpdateUrl="createUpdateUrl" :deleteUrl="deleteUrl"
                        :curTab="curTab" />
                </v-tab>
                <v-tab title="current-issues">
                    <CategoryCompo :getUrl="getUrl" :createUpdateUrl="createUpdateUrl" :deleteUrl="deleteUrl"
                        :curTab="curTab" />
                </v-tab>
                <v-tab title="events">
                    <CategoryCompo :getUrl="getUrl" :createUpdateUrl="createUpdateUrl" :deleteUrl="deleteUrl"
                        :curTab="curTab" />
                </v-tab>
            </vue-tabs>
        </div>
    </div>

</template>
<script>

//import DeleteConfirm from "@/components/Delete-Confirm.vue";
import CategoryCompo from "./CategoryCompo.vue";

import { commonMixins } from "../../assets/mixins/common.js";

export default {
    components: { CategoryCompo },
    mixins: [commonMixins],
    name: "PartnersCategory",
    created() {
        console.log('created', this.curTab)
        const self = this;
        self.getUrl = "/frontend/category/marketing/get";
        self.createUpdateUrl = "/frontend/category/marketing/update";
        self.deleteUrl = "frontend/category/marketing/delete";
        //self.curTab = "marketing";
    },
    data() {
        return {
            curTab: "",
            getUrl: "/frontend/category/marketing/get",
            createUpdateUrl: "/frontend/category/marketing/update",
            deleteUrl: "frontend/category/marketing/delete",
        };
    },
    methods: {
        getTabData(tabIndex, newTab, oldTab) {
            console.log('tabs:', tabIndex, newTab.title, oldTab.title);
            if (newTab.title === 'marketing') {
                this.getUrl = "/frontend/category/marketing/get";
                this.createUpdateUrl = "/frontend/category/marketing/update";
                this.deleteUrl = "frontend/category/marketing/delete";
            } else if (newTab.title === 'current-issues') {
                this.getUrl = "/frontend/category/current-issues/get";
                this.createUpdateUrl = "/frontend/category/current-issues/update";
                this.deleteUrl = "/frontend/category/current-issues/delete";
            } else if (newTab.title === 'events') {
                this.getUrl = "/frontend/category/events/get";
                this.createUpdateUrl = "/frontend/category/events/update";
                this.deleteUrl = "/frontend/category/events/delete";
            }
            this.curTab = newTab.title;
        },
    },
};
</script>
<style scoped>
.category-edit {
    background-color: #d3ebef;
    border-radius: 5px;
    margin: 1rem;
}

.label-cs {
    min-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/views/partners/PartnersCategory.vue